import { lastValueFrom } from 'rxjs';

import { getApiUrl, API_URL } from '@/utils/api';
import { AppFullLocale, AppSubLocale } from '@/types';

import ApiBase from './ApiBase';

export default class StoreService extends ApiBase {
  static baseUrl = getApiUrl(API_URL.ADMIN, '/storeInfo');

  getStoreConfByLocale(locale: AppFullLocale, storeIdForPrice: string) {
    let options = { cache: 'force-cache' as const, cookies: undefined };
    if (storeIdForPrice) {
      options = { ...options, cookies: `storeIdForPrice=${storeIdForPrice}` };
    }
    return this.api.getJSON(`${StoreService.baseUrl}/byLocale/${locale}`, options);
  }

  getStoreConfByCodeIso(locale: AppSubLocale, storeIdForPrice: string) {
    let options = { cache: 'force-cache' as const, cookies: undefined };
    if (storeIdForPrice) {
      options = { ...options, cookies: `storeIdForPrice=${storeIdForPrice}` };
    }
    return this.api.getJSON(`${StoreService.baseUrl}/byCodeIso/${locale}`, options);
  }

  getStoreConfByHost(host: string, storeIdForPrice: string) {
    if (host.startsWith('localhost')) {
      host = process.env.NEXT_PUBLIC_DEFAULT_HOST || 'dev-fr.millesima.com';
    }
    let options = { cache: 'force-cache' as const, cookies: undefined };
    if (storeIdForPrice) {
      options = { ...options, cookies: `storeIdForPrice=${storeIdForPrice}` };
    }
    return this.api.getJSON(`${StoreService.baseUrl}/byHost?host=${host}`, options);
  }

  getStoreConfByStoreId(storeId: string) {
    return lastValueFrom(this.api.getJSON(`${StoreService.baseUrl}/byStoreId/${storeId}`));
  }
}
